var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('ConsolidatedRegion',{attrs:{"events":_vm.consolidatedData,"states":_vm.cptStates,"region":_vm.region,"total":_vm.totalDevices,"state":_vm.state,"loaderData":_vm.loaderData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }